import { AmbientLight, MathUtils, Scene, Vector3 } from "three";
import { MouseEvents } from "../../../componets3D/MouseEvents";
import { CameraController } from "../../../componets3D/CameraController";
import { Cube } from "../../objects/Cube";
import ObserverEmitter, { EVENTS } from "../../../../emitter/Observer";

import { OxxoMapActvFour } from "../../objects/Tema1/subtopicFour/OxxoMapActvFour";
import { CharcterOxxo } from "../../objects/CharacterOxxo";
import { Etiquetas } from "../../objects/Tema1/subtopicFour/Etiquetas";
import { ProductsPAR } from "../../objects/Tema1/subtopicFour/ProductsPAR";
import { BoxPAR } from "../../objects/Tema1/subtopicFour/BoxPAR";
import { gsap } from "gsap";
import { CustomEase } from "gsap/CustomEase";
import { HandHeld } from "../../objects/Tema1/subtopicFour/HandHeld";
import { audiosAssets } from "../../../../assets/audio";

// const _PI_2 = Math.PI / 2;
// const _euler = new Euler(0, 0, 0, "YXZ");
export class SceneTopicFour extends Scene {
	constructor(loadingManager, container, render, characterSelected = new CharcterOxxo(), enviroment) {
		super();
		this.characterSelected = characterSelected;
		this.environment = enviroment;
		this.camera = new CameraController();
		this.loadingManager = loadingManager;
		this.mouseEvents = new MouseEvents(container, render, this.camera, this);
		this.create();
		this.light();
		this.pointsActivityTwo = 0;
		this.activityIntents = 0
		// this.helper();
		this.renderAnimations();
		this.observerListeners();
	}
	create() {
		this.add(this.characterSelected);

		this.mapmenu = new OxxoMapActvFour(this.loadingManager);
		this.add(this.mapmenu);

		this.handheld = new HandHeld(this.camera);
		// this.add(this.handheld);

		this.etiquetas = new Etiquetas(this.loadingManager);
		this.add(this.etiquetas);

		this.cubeExample = new Cube(0.3, { x: -11.2, y: -0.8, z: -2.7 });
		this.add(this.cubeExample);

		this.productsPar = new ProductsPAR();
		this.add(this.productsPar);
		this.boxPar = new BoxPAR();
		this.add(this.boxPar);
		// this.boxPar.visible = false;

		this.cubeExample.visible = false;
	}

	SceneInitialState() {
		this.mouseEvents.disposeInteractions();
	}

	observerListeners() {
		ObserverEmitter.on(EVENTS.subtopicFour.activityOne.moveToTicket, () => {
			this.camera.moveCameraToPoint(new Vector3(-11.6762, -0.4382, -2.1663), 1, new Vector3(-11.091, -0.918, -2.82), () => {
				this.mouseEvents.objectsToValue = [this.cubeExample];
				this.mouseActionsActivityOne();
				this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
				this.camera.control.minPolarAngle = MathUtils.degToRad(20);
				this.camera.control.enableRotate = false;
				this.camera.control.maxAzimuthAngle = -0.441;
				this.camera.control.minAzimuthAngle = -1.525;
				this.camera.control.minDistance = 1;
				this.camera.control.maxDistance = 3;
				this.camera.control.enablePan = false;
			});
		});

		ObserverEmitter.on(EVENTS.subtopicFour.activityTwo.visibleObjetProductsOnly, (value) => {
			const namesObjects = ["Celular", "Cigarros", "Dinero_1", "Botella_1"];
			if (!namesObjects.includes(value)) {
				return;
			}
			this.productsPar.Celular.visible = value === "Celular";
			this.productsPar.Cigarros.visible = value === "Cigarros";
			this.productsPar.Dinero_1.visible = value === "Dinero_1";
			this.productsPar.Botella_1.visible = value === "Botella_1";
		});

		ObserverEmitter.on(EVENTS.subtopicFour.activityTwo.visibleObjetProductsAll, () => {
			this.productsPar.Botella_1.visible = false;
			this.characterSelected.visible = false;
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-7.3646, 1.6554, 5.0089), 1, new Vector3(-9.23, 0.18, 3.521), () => {
				this.camera.control.maxPolarAngle = MathUtils.degToRad(85);
				this.camera.control.minPolarAngle = MathUtils.degToRad(40);
				this.camera.control.enableRotate = false;
				this.camera.control.maxAzimuthAngle = 1.279;
				this.camera.control.minAzimuthAngle = 0.171;
				this.camera.control.minDistance = 0.1;
				this.camera.control.maxDistance = 10;
				this.camera.control.enablePan = false;

				this.productsPar.position.set(1.4, 0.33, 0.84);
				this.productsPar.Celular.position.set(-25, 24, 0);
				this.productsPar.Celular.rotation.set(0, 0, 0);
				this.productsPar.Cigarros.position.set(-13, 12, 0);
				this.productsPar.Cigarros.rotation.set(0, 0, 0);
				this.productsPar.Dinero_1.position.set(-0.00004, 0.000024, 0);
				this.productsPar.Dinero_1.rotation.set(0, 0, 0);
				this.productsPar.Botella_1.position.set(19, -18, 0);
				this.productsPar.Botella_1.rotation.set(0, 0, 0);
				this.productsPar.Celular.visible = true;
				this.productsPar.Cigarros.visible = true;
				this.productsPar.Dinero_1.visible = true;
				this.productsPar.Botella_1.visible = true;
			});
		});
	}
	onListenerActvityOne() {
		ObserverEmitter.on(EVENTS.subtopicFour.activityOne.moveZoom, () => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-0.1194, -0.7678, 3.7318), 1, new Vector3(-0.12, -0.781, 3.633), () => {
				this.camera.control.enableRotate = false;
				this.camera.control.enablePan = false;
			});
		});
		ObserverEmitter.on(EVENTS.subtopicFour.activityOne.moveOut, () => {
			this.camera.moveCameraToPoint(new Vector3(0.0678, -0.7665, 4.7543), 1, new Vector3(0.064, -0.915, 3.65), () => { });
		});
		ObserverEmitter.on(EVENTS.subtopicFour.activityOne.visibleHandler, () => {
			this.handheld.visible = true
			this.add(this.handheld);
		});
	}

	onStateActivityTwo() {
		this.activityIntents = 0
		this.characterSelected.visible = true;
		this.characterSelected.onAnimateSaludo();
		this.characterSelected.position.set(-10.5846, -0.9809, -1.9341);
		this.characterSelected.rotation.set(0, -1.5145, 0);

		this.productsPar.position.set(-0.4118, -0.8529, -5.7052);
		this.productsPar.Celular.position.set(55.8715, 24, 0);
		this.productsPar.Celular.rotation.set(-0.7646, -1.0955, 0);
		this.productsPar.Cigarros.position.set(66.8993, 22.788, 0);
		this.productsPar.Cigarros.rotation.set(0, 0, -1.9777);
		this.productsPar.Dinero_1.position.set(55.8715, 22.788, 0);
		this.productsPar.Dinero_1.rotation.set(0, -0.5441, 0);
		this.productsPar.Botella_1.position.set(44.8436, 22.788, 0);
		this.productsPar.Botella_1.rotation.set(0, 0, 4.1979);
		this.productsPar.Celular.visible = false;
		this.productsPar.Cigarros.visible = false;
		this.productsPar.Dinero_1.visible = false;
		this.productsPar.Botella_1.visible = false;

		this.mapmenu.clearAnimations()
		this.animateSelected()
		this.pointsActivityTwo = 0;
		this.activityIntents = 0
		// this.productsPar.helpersChild();

		this.handheld.visible = false;
		ObserverEmitter.on(EVENTS.subtopicFour.activityTwo.initActovity, () => {
			this.mouseEvents.disposeInteractions();
			this.mouseEvents.objectsToValue = [this.boxPar, this.productsPar];
			this.mapmenu.animateBotellas();
			this.mapmenu.animateCajaFuerte();
			this.mapmenu.animateCigarros();
			this.mapmenu.animateUSB();
			this.mouseActionsActivityTwo();
		});
	}

	activeAudio() {
		ObserverEmitter.emit(EVENTS.audioInitByTopic)
	}

	ActivitiSelected(activity) {
		switch (activity) {
			case 0:
				this.camera.moveCameraToPoint(new Vector3(-10.883, 2.298, -2.2733), 1, new Vector3(-10.005, -0.371, -1.869), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;
					this.activeAudio()
				});
				break;
			case 1:
				this.camera.moveCameraToPoint(new Vector3(-8.5417, -1.1883, -3.6896), 1, new Vector3(-7.54, -1.396, -3.553), () => {
					this.onListenerActvityOne();
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					// this.camera.control.maxAzimuthAngle = Infinity;
					// this.camera.control.minAzimuthAngle = Infinity;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.characterSelected.visible = true;
					this.characterSelected.onAnimateSaludo();
					this.characterSelected.position.set(-6.7821, -1.7797, -3.4572);
					this.characterSelected.rotation.set(0, -1.6841, 0);

					this.handheld.position.set(-0.13, -0.6811, 4.2052)
					this.handheld.visible = false
					this.handheld.initDataStep()

					this.etiquetas.setPositionEtiquetas()
					// this.handheld.helpers()
					this.activeAudio()
				});
				break;
			case 2:
				this.camera.control.maxAzimuthAngle = Infinity;
				this.camera.control.minAzimuthAngle = Infinity;
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;
					this.onStateActivityTwo();
					this.activeAudio()
				});
				break;

			default:
				this.camera.control.maxAzimuthAngle = Infinity;
				this.camera.control.minAzimuthAngle = Infinity;
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					// this.camera.control.maxAzimuthAngle = -0.86;
					// this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.characterSelected.visible = false;

					this.activeAudio()
				});
				break;
		}
	}

	light() {
		this.ambient = new AmbientLight();
		this.ambient.color.set(0xffffff);
		this.ambient.intensity = 1;
		this.add(this.ambient);
	}

	mouseActionsActivityOne() {
		this.mouseEvents.onPointerUp((interactions) => {
			if (interactions[0]) {
				switch (interactions[0].object.name) {
					case "cube-0.3":
						ObserverEmitter.emit(EVENTS.subtopicFour.activityOne.clickonTiket);
						// this.etiquetas.onChangeNewEtiquetaPosition();
						this.camera.control.maxAzimuthAngle = Infinity;
						this.camera.control.minAzimuthAngle = Infinity;
						this.camera.moveCameraToPoint(new Vector3(-0.3764, -0.5229, 3.4127), 1, new Vector3(-0.344, -0.671, 2.309), () => {
							this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
							this.camera.control.minPolarAngle = MathUtils.degToRad(20);
							this.camera.control.enableRotate = false;
							this.camera.control.maxAzimuthAngle = 0.359;
							this.camera.control.minAzimuthAngle = -0.347;
							this.camera.control.minDistance = 1;
							this.camera.control.maxDistance = 3;
							this.camera.control.enablePan = false;
						});
						break;

					default:
						break;
				}
			}
		});
	}

	objectAnimateToPosition(object, position) {
		const timeline = gsap.timeline();

		timeline.to(object.position, {
			duration: 1,
			x: position.x,
			y: position.y,
			z: position.z,
			onComplete: () => {
				object.position.z += 1000;
			},
		});
		timeline.play();
	}

	evaluateActvTwo(produc, box) {
		if (produc.name === "Botella_1" && box.name === "box_alchol") {
			this.mapmenu.killAnimationBotellas();
			box.position.y += 500;
			this.pointsActivityTwo++;
			this.objectAnimateToPosition(produc, { x: 282, y: 309, z: 62 });
		} else if (produc.name === "Dinero_1" && box.name === "box_dinero") {
			this.mapmenu.killAnimationCajaFuerte();
			box.position.y += 500;
			this.pointsActivityTwo++;
			this.objectAnimateToPosition(produc, { x: 261, y: 496, z: 123 });
		} else if (produc.name === "Cigarros" && box.name === "box_cigarros") {
			this.mapmenu.killAnimationcigarros();
			box.position.y += 500;
			this.pointsActivityTwo++;
			this.objectAnimateToPosition(produc, { x: 300, y: 192, z: 46 });
		} else if (produc.name === "Celular" && box.name === "box_celular") {
			this.mapmenu.killAnimateUsb();
			box.position.y += 500;
			this.pointsActivityTwo++;
			this.objectAnimateToPosition(produc, { x: 142.7, y: 100.4, z: 119.6 });
		} else {
			console.log('me equivoque', this.activityIntents);
			if (this.activityIntents === 2) {
				ObserverEmitter.emit(EVENTS.subtopicFour.activityTwo.failActivity);
			}
			this.activityIntents++
			const timeline = gsap.timeline();

			timeline.to(produc.position, {
				duration: 0.15,
				x: produc.position.x,
				y: produc.position.y - 2,
				z: produc.position.z,
				onComplete: () => { },
				ease: CustomEase.create("custom", "M0,0 C0.126,0.382 0.201,1.167 0.262,0.96 0.87,-1.12 0.614,2.65 1,0.01 "),
			});
			timeline.play();
		}
		if (this.pointsActivityTwo === 4) {
			ObserverEmitter.emit(EVENTS.subtopicFour.activityTwo.winActivity);
			// this.characterSelected.visible = true;
			// this.characterSelected.onAnimationFestejo();
		}
	}

	animateSelected(object) {
		if (this.objectAnimated) {
			this.objectAnimated.kill();
			if (this.objectAnimatedSelected) {
				this.objectAnimatedSelected.material.emissive.setHex(0xffffff);
				this.objectAnimatedSelected.material.emissiveIntensity = 0;
			}
		}

		if (!object) {
			return
		}
		this.objectAnimatedSelected = object;
		object.material.emissive.setHex(0xffffff);
		// object.material.emissive.setHex(0xf7e840);
		object.material.emissiveIntensity = 0;
		this.objectAnimated = gsap.to(object.material, {
			emissiveIntensity: 0.8,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
	}

	mouseActionsActivityTwo() {
		let productcliked;
		this.mouseEvents.onPointerUp((interactions) => {
			if (interactions[0]) {
				// console.log(interactions[0].object.name);
				if (productcliked && interactions[0].object.name.includes("box_")) {
					ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.gestos.gestoLugar)
					this.evaluateActvTwo(productcliked, interactions[0].object);
				} else {
					ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.gestos.gestoObjeto)
					productcliked = interactions[0].object;
					this.animateSelected(interactions[0].object);
				}
			}
		});
	}

	renderAnimations(delta) {
		// this.handheld.renderAnimations(delta);
	}
}
